import Pkg from "../package.json" with { type: "json" };

// Define interface for the exported configuration
interface AppConfig {
  appName: string;
  cacheVersion: string;
  viewVersion: string;
  host: {
    shopping: string;
    udb: string;
    pay: string;
    activity: string;
    customer: string;
    global: string;
    help: string;
    imservice: string;
  };
  userAgentCacheKey: string;
  requestRejectType: {
    multipleRequest: {
      resultCode: string;
      resultMessage: string;
      data: null;
    };
    serviceError: {
      resultCode: string;
      resultMessage: string;
      data: null;
    };
    netError: {
      resultCode: string;
      resultMessage: string;
      data: null;
    };
  };
  businessRequest: {
    sign: {
      signKey: string;
      xxTeaKey: string;
      signAccountKey: string;
    };
    projectInfo: {
      ProductID: number;
      CHID: number;
      VerID: string;
      VerCode: string;
      CHCode: string;
      ProjectID: number;
      PlatForm: number;
      DeviceType: number;
      ClientHeaderVerID: number;
    };
  };
}

const protocol: string = window.location.protocol;

/**
 * 按构建环境选取接口 Host
 * 分支条件需直接使用 import.meta.env：构建时会被替换为字面量，未命中的环境分支会被移除，
 * 避免把其他环境（外测/内测）的域名打进产物
 */
const getHost = (): AppConfig["host"] => {
  // 本地开发环境，可用 localhost 或者 ip 启动，走 vite 代理
  if (import.meta.env.VITE_APP_LOCAL_ENV === "dev") {
    return {
      shopping: "/proxy_shopping",
      udb: "/proxy_udb",
      pay: "/proxy_pay",
      activity: "/proxy_activity",
      customer: `${protocol}//h5.dev.babybus.com/customer/v2`,
      global: "/proxy_global",
      help: "/proxy_help",
      imservice: "/proxy_imservice",
    };
  }

  // 内测环境 bugu-mall-dev.babybus.com
  if (import.meta.env.VITE_APP_ENV === "dev") {
    return {
      shopping: `${protocol}//ShoppingMallApi.Development.platform.babybus.com`,
      udb: `${protocol}//udb.development.platform.babybus.com`,
      pay: `${protocol}//payapi.development.platform.babybus.com`,
      activity: `${protocol}//act.development.platform.babybus.com`,
      customer: `${protocol}//h5.dev.babybus.com/customer/v2`,
      global: `${protocol}//apiconfig.development.platform.babybus.com`,
      help: `${protocol}//apphelpcenter.development.platform.babybus.com`,
      imservice: `${protocol}//imservice-api.development.platform.babybus.com`,
    };
  }

  // 外测环境 bugu-mall.beta.babybus.com
  if (import.meta.env.VITE_APP_ENV === "beta") {
    return {
      shopping: `${protocol}//ShoppingMallApi.Staging.platform.babybus.com`,
      udb: `${protocol}//udb.staging.platform.babybus.com`,
      pay: `${protocol}//payapi.staging.platform.babybus.com`,
      activity: `${protocol}//act.staging.platform.babybus.com`,
      customer: `${protocol}//h5.sim.babybus.com/customer/v2`,
      global: `${protocol}//apiconfig.staging.platform.babybus.com`,
      help: `${protocol}//apphelpcenter.staging.platform.babybus.com`,
      imservice: `${protocol}//imservice-api.babybus.com`,
    };
  }

  // 正式环境 bugu-mall.babybus.com
  return {
    shopping: `${protocol}//shoppingmallapi.babybus.com`,
    udb: `${protocol}//udb.babybus.com`,
    pay: `${protocol}//payapi.babybus.com`,
    activity: `${protocol}//act.babybus.com`,
    customer: `${protocol}//cdnjs.babybus.com/customer/v2`,
    global: `${protocol}//api-config.babybus.com`,
    help: `${protocol}//apphelpcenter.babybus.com`,
    imservice: `${protocol}//imservice-api.babybus.com`,
  };
};

const config: AppConfig = {
  appName: "小布咕商城",
  cacheVersion: "2.2.0",
  viewVersion: "3.3.1",
  // 接口Host
  host: getHost(),
  userAgentCacheKey: "UserAgent",
  requestRejectType: {
    multipleRequest: {
      resultCode: "-1112",
      resultMessage: "",
      data: null,
    },
    serviceError: {
      resultCode: "0",
      resultMessage: "",
      data: null,
    },
    netError: {
      resultCode: "-2",
      resultMessage: "",
      data: null,
    },
  },
  businessRequest: {
    // 签名密钥
    sign: {
      signKey: "ac076bbace164c96a4c27f225bedc80e",
      xxTeaKey: "HKqGu4X0dCRzxirZuHLVCJRhu2qqH7ro",
      signAccountKey: "",
    },
    // 默认的 UserAgentInfo
    projectInfo: {
      ProductID: 3302,
      CHID: 1,
      VerID: Pkg.version.split(".").join(""),
      VerCode: Pkg.version,
      CHCode: "",
      ProjectID: 4,
      PlatForm: 27,
      DeviceType: 0,
      ClientHeaderVerID: 2, //客户端头部结构版本号（跟产品无关），有改动头部结构的情况下都自增1
    },
  },
};

export default config;
